import { combineReducers } from 'redux';

import { reducer as auth } from './auth.reducers';
import { reducer as organisation } from './organisation.reducers';
import { reducer as register } from './register.reducers';
import { reducer as inviteusers } from './inviteusers.reducers';
import { reducer as organisationparticipantsummaryreport } from './organisationparticipantsummaryreport.reducers';
import { reducer as overallsummary } from './overallsummaryreport.reducers';
import { reducer as forgotpassword } from './forgotpassword.reducers';
import { reducer as admin } from './admin.reducers';
import { AppState } from '../types/app-state';

export const reducers = combineReducers<AppState>({
  admin, auth, organisation, register, inviteusers,
  overallsummary, organisationparticipantsummaryreport, forgotpassword
});